import styled from 'styled-components';

export const StyledApp = styled.div`
  text-align: center;
  min-height: 80px;
`;

export const StyledBody = styled.div`
  min-height: calc(100vh - 80px);
  background-color: #F8F8F8;
`;